// eslint-disable-next-line no-undef
const BASE_URL = process.env.REACT_APP_API_URL
console.log(BASE_URL)

const requestOptionsToken = (token, method, infos) => {
  const head = {
    method: method || 'GET',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }
  if (infos) {
    head.body = JSON.stringify(infos)
  }
  return head
}

const api = {
  forgotPassword: async (email) => {
    const response = await fetch(
      `${BASE_URL}/auth/forgotPassword`,
      requestOptionsToken(null, 'POST', email)
    )
    if (!response.ok) {
      const { message } = await response.json()
      console.log(message)
      throw new Error(message)
    }
  },
  resetPassword: async (id, token, infos) => {
    const response = await fetch(
      `${BASE_URL}/auth/resetPassword/${id}/${token}`,
      requestOptionsToken(null, 'POST', infos)
    )
    if (!response.ok) {
      const { message } = await response.json()
      console.log(message)
      throw new Error(message)
    }
  },
  getProducts: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/product`, requestOptionsToken(token))
    const data = response.json()
    return data
  },
  getFixedExpenses: async () => {
    console.log(1)
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/fixed`, requestOptionsToken(token))
    const data = await response.json()

    return data
  },
  getMethodsSales: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/methodsSales`, requestOptionsToken(token))
    const data = await response.json()
    return data
  },
  getNotesSales: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/notesSales`, requestOptionsToken(token))
    const data = await response.json()
    return data
  },
  getAppSales: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/appSales`, requestOptionsToken(token))
    const data = await response.json()
    return data
  },

  getWithNotes: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/notesSales/withNote`, requestOptionsToken(token))
    const data = await response.json()
    return data
  },

  getFixedSalesExpenses: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/fixedSales`, requestOptionsToken(token))
    const data = await response.json()

    return data
  },

  getPlataforms: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/plataforms`, requestOptionsToken(token))
    const data = response.json()
    return data
  },
  addProduct: async (infos) => {
    const token = localStorage.getItem('authToken')

    const response = await fetch(`${BASE_URL}/product`, requestOptionsToken(token, 'POST', infos))

    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  addMethodsSales: async (infos) => {
    const token = localStorage.getItem('authToken')

    const response = await fetch(
      `${BASE_URL}/methodsSales`,
      requestOptionsToken(token, 'POST', infos)
    )

    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },
  addNotesSales: async (infos) => {
    const token = localStorage.getItem('authToken')

    const response = await fetch(
      `${BASE_URL}/notesSales`,
      requestOptionsToken(token, 'POST', infos)
    )

    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  addAppSales: async (infos) => {
    const token = localStorage.getItem('authToken')

    const response = await fetch(`${BASE_URL}/appSales`, requestOptionsToken(token, 'POST', infos))

    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  updateProduct: async (infos) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/product/${infos.id}`,
      requestOptionsToken(token, 'PUT', infos)
    )
    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  updateFixedExpenses: async (infos) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/fixed/${infos.id}`,
      requestOptionsToken(token, 'PUT', infos)
    )
    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  updateVariablesExpenses: async (infos) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/variables/${infos.id}`,
      requestOptionsToken(token, 'PUT', infos)
    )
    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  updateFixedExpensesSales: async (infos) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/fixedSales/${infos.id}`,
      requestOptionsToken(token, 'PUT', infos)
    )
    if (!response.ok) {
      console.log(response.json())
      throw new Error('Falha na requisição')
    }
    const data = await response.json()
    return data
  },

  addFixedExpense: async (infos) => {
    try {
      const token = localStorage.getItem('authToken')
      const response = await fetch(`${BASE_URL}/fixed`, requestOptionsToken(token, 'POST', infos))

      if (!response.ok) {
        throw new Error('Falha na requisição')
      }
      const data = await response.json()
      console.log(data)

      return data
    } catch (e) {
      return
    }
  },
  addVariableExpense: async (infos) => {
    try {
      const token = localStorage.getItem('authToken')
      const response = await fetch(
        `${BASE_URL}/variables`,
        requestOptionsToken(token, 'POST', infos)
      )

      if (!response.ok) {
        throw new Error('Falha na requisição')
      }
      const data = await response.json()
      console.log(data)

      return data
    } catch (e) {
      return
    }
  },

  addFixedExpenseSales: async (infos) => {
    try {
      const token = localStorage.getItem('authToken')
      const response = await fetch(
        `${BASE_URL}/fixedSales`,
        requestOptionsToken(token, 'POST', infos)
      )

      if (!response.ok) {
        throw new Error('Falha na requisição')
      }
      const data = await response.json()
      console.log(data)

      return data
    } catch (e) {
      return
    }
  },
  addPlataforms: async (infos) => {
    try {
      const token = localStorage.getItem('authToken')
      const response = await fetch(
        `${BASE_URL}/plataforms`,
        requestOptionsToken(token, 'POST', infos)
      )

      if (!response.ok) {
        throw new Error('Falha na requisição')
      }
      const data = await response.json()

      return data
    } catch (e) {
      return
    }
  },
  deleteProduct: async (id) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/product/${id}`, requestOptionsToken(token, 'DELETE'))
    if (!response.ok) {
      throw new Error('Falha na requisição')
    }
    const data = response.json()
    return data
  },

  addMadeProduct: async (infos) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/productmade`,
      requestOptionsToken(token, 'POST', infos)
    )
    console.log(response)
    if (!response.ok) {
      const { message } = await response.json()
      console.log(message)
      throw new Error('Falha na requisição')
    }
  },

  deleteMadeProduct: async (id) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/productmade/${id}`,
      requestOptionsToken(token, 'DELETE')
    )

    const data = response.json()
    if (!response.ok) {
      console.log(response)
      throw new Error('Falha ao deletar produto')
    }
    return data
  },

  deleteFixedExpenses: async (id) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/fixed/${id}`, requestOptionsToken(token, 'DELETE'))

    const data = response.json()
    if (!response.ok) {
      throw new Error('Falha ao deletar produto')
    }
    return data
  },
  deleteVariablesExpenses: async (id) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/variables/${id}`,
      requestOptionsToken(token, 'DELETE')
    )

    const data = response.json()
    if (!response.ok) {
      throw new Error('Falha ao deletar produto')
    }
    return data
  },

  deleteMethodsSales: async (id) => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(
      `${BASE_URL}/methodsSales/${id}`,
      requestOptionsToken(token, 'DELETE')
    )

    const data = response.json()
    if (!response.ok) {
      throw new Error('Falha ao deletar produto')
    }
    return data
  },

  getAllMadeProducts: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/productmade`, requestOptionsToken(token))

    const data = response.json()
    return data
  },

  signIn: async (email, password) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      mode: 'cors',
      body: JSON.stringify({
        email,
        password,
      }),
    }

    const response = await fetch(`${BASE_URL}/auth/login`, requestOptions)
    return response.json()
  },

  validateToken: async (token) => {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        authorization: `Bearer ${token}`,
      },
      mode: 'cors',
    }
    const response = await fetch(`${BASE_URL}/auth/validateToken`, requestOptions)
    return response.json()
  },

  updateExpenses: async (infos) => {
    const token = localStorage.getItem('authToken')

    const response = await fetch(
      `${BASE_URL}/auth/updateExpenses`,
      requestOptionsToken(token, 'PUT', infos)
    )
    const data = response.json()
    console.log(data)
    return data
  },

  getProfile: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/auth/getProfile`, requestOptionsToken(token))
    const data = response.json()
    return data
  },
}

export default api
